import { render, staticRenderFns } from "./SyncPage.vue?vue&type=template&id=131982a6&scoped=true&"
import script from "./SyncPage.vue?vue&type=script&lang=js&"
export * from "./SyncPage.vue?vue&type=script&lang=js&"
import style0 from "./style.scss?vue&type=style&index=0&id=131982a6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "131982a6",
  null
  
)

export default component.exports